import * as Cookies from 'js-cookie';
import MobileNav from '../components/MobileNav';
import throttle from 'lodash.throttle';

export default {
    init() {
        // JavaScript to be fired on all pages
        this.initMobileNav();
        this.initFixedNav();
        this.initOffsetAnchorScroll();

        let onPageNavComponent = document.body.querySelector('.flex__component__on-page-nav');
        if (onPageNavComponent) {
            this.initOnPageNavClick();
        }

        /**
         *
         * Class toggle for flex module info boxes
         *
         */
        let flexModuleInfoToggle = $('.flex-module-info-toggle');
        let flexModuleInfo = $('.flex-module-info');

        flexModuleInfoToggle.on('click', function() {
            flexModuleInfo.toggle();
        });

        // Normalize carousel slide heights
        $(window).on('load', this.normalizeSlideHeights);

        let searchOpen = false;
        let $searchInput = $('#globalSearchForm__input');
        let $searchOpenBtn = $('#globalSearchForm__btn');
        let $searchSubmitBtn = $('#globalSearchForm__btn--open');

        $searchOpenBtn.on('click', function(event) {
            if (searchOpen === false) {
                event.preventDefault();
                $('.layout-search__drawer').addClass('open');
                $searchInput.trigger('focus');
                $searchOpenBtn.hide();
                $searchSubmitBtn.show();
                searchOpen = true;
            }
        });
    },

    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        // let videoPlaceholderElements = document.getElementsByClassName('video-embed--placeholder');
        let videoPlaceholderElements = document.body.querySelectorAll('.video-embed--placeholder > div');
        Array.from(videoPlaceholderElements).forEach(function(videoPlaceholderElement) {
            // let wrapperBlock = document.createElement('div');
            videoPlaceholderElement.addEventListener('click', function() {
                let placeholderParent = this.parentNode;

                // let videoOembedElement = placeholderParent.querySelector('.video-embed--oembed');
                // this.remove();
                // videoOembedElement.style.opacity = '1';
                // videoOembedElement.style.visibility = 'visible';
                // videoOembedElement.style.position = 'relative';

                let iframeSrcUrl = new URL(placeholderParent.getAttribute('data-video-url'));
                let iframeSrcParams = new URLSearchParams(iframeSrcUrl.search);
                iframeSrcParams.append('autoplay', '1');
                iframeSrcParams.append('showinfo', '0');
                iframeSrcParams.append('color', 'white');
                iframeSrcParams.append('modestbranding', '1');
                iframeSrcParams.append('wmode', 'opaque');
                iframeSrcParams.append('rel', '0');

                let wrapperBlock = document.createElement('div');
                wrapperBlock.setAttribute('class', 'embed-responsive embed-responsive-16by9');
                let videoIframe = document.createElement('iframe');
                videoIframe.setAttribute('src', `${iframeSrcUrl.toString()}?${iframeSrcParams.toString()}`);
                videoIframe.setAttribute('frameborder', '0');
                videoIframe.setAttribute('allowfullscreen', '');
                videoIframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
                videoIframe.setAttribute('class', 'embed-responsive-item');
                wrapperBlock.appendChild(videoIframe);
                placeholderParent.replaceWith(wrapperBlock);
            });
        });

        // On modal close, reset iframe src, which stops te video from playing.
        $('#ModalId_Home').on('hidden.bs.modal', function() {
            $('#ModalId_Home iframe').attr('src', $('#ModalId_Home iframe').attr('src'));
        });

        // Set a cookie when a visitor dismisses an alert/notification
        $('.alert-notification').on('close.bs.alert', function(event) {
            let element = event.target;
            Cookies.set('notification_' + element.dataset.notification, Date.now(), {
                expires: new Date(element.dataset.expiration * 1000),
            });
        });
    },

    normalizeSlideHeights() {
        $('.testimonialSlider .carousel').each(function() {
            let items = $('.carousel-item', this);
            let itemsParent = $('.carousel-item', this);
            // reset the height
            items.css('min-height', 0);
            // set the height
            let maxHeight = Math.max.apply(
                null,
                items
                    .map(function() {
                        return $(this).outerHeight();
                    })
                    .get()
            );
            itemsParent.css('min-height', maxHeight + 'px');
        });
    },

    initMobileNav() {
        new MobileNav();
    },

    initFixedNav() {
        window.addEventListener('scroll', throttle(this.handleFixedNavScroll.bind(this), 250), {passive: true});
        this.handleFixedNavScroll();
        
    },

    // Global offset for named anchors
    initOffsetAnchorScroll() {
        let anchorElement = $(window.location.hash);

        if (anchorElement.length) {
            let offsetSize = $('.layout-header').innerHeight() + $('.flex__component__on-page-nav').innerHeight();
            $('html, body').animate({ scrollTop: anchorElement.offset().top - offsetSize }, 500);

        }
    },

    initOnPageNavClick() {
        $('.nav-onpage-link').on('click', function(event) {
            let navOffsetSize = $('.layout-header').innerHeight() + $('.flex__component__on-page-nav').innerHeight();
            let anchorLocation = $(event.target).attr('href');
            let anchorElement = $(anchorLocation);
            if (anchorElement.length) {
                $('html, body').animate({scrollTop: anchorElement.offset().top - navOffsetSize - (navOffsetSize * !$('.layout-header').hasClass('layout-header--fixed'))}, 500);
            }
        });
    },

    handleFixedNavScroll() {
        /*
            This targets the .layout-navbar but could easily be adapted to
            incorporate the entire .layout-header. CSS would need to be altered/moved to
            fully put that change in effect.
        */
        const headerFixed = 'layout-header--fixed';
        // const headerHidden = 'layout-header--hidden';

        let body = document.body;
        let headerBar = body.querySelector('.layout-header');
        let fixedInitial = document.querySelector('.layout-header').offsetHeight;
        let onPageNavComponent = body.querySelector('.flex__component__on-page-nav');
        let screenWidth = screen.width;

        if (document.documentElement.scrollTop > fixedInitial) {
            headerBar.classList.add(headerFixed);

            if (onPageNavComponent !== null) {
                onPageNavComponent.style.top = fixedInitial + 'px';
                onPageNavComponent.classList.add('fixed-top');
            }

            if (screenWidth < 768 && onPageNavComponent !== null) {
                onPageNavComponent.classList.remove('fixed-top');
                onPageNavComponent.style.removeProperty('top');
            }
        } else {
            headerBar.classList.remove(headerFixed);

            if (onPageNavComponent !== null ) {
                onPageNavComponent.classList.remove('fixed-top');
                onPageNavComponent.style.removeProperty('top');
            }
        }
    },
};
